import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useOutlet } from 'react-router-dom';

import NSCWrapper from '@components/NSCWrapper';
import ThemeSwitcher from '@components/ThemeSwitcher';
import LoadingAuth from '@components/loadingViews/LoadingAuth';
import LoadingGlobal from '@components/loadingViews/LoadingGlobal';
import { useAppSelector } from '@core/hooks/appHooks';
import { useDelayUnmount } from '@core/hooks/useDelayUnmount';
import { selectIsLoading } from '@core/store/appSlice/appSlice';
import { useAuth } from '@providers/authProvider';

const ProtectedRoute: React.FC = () => {
  const [isFetchingUser, setIsFetchingUser] = useState(true);

  /**
   * User
   */
  const { userAccount } = useAuth();
  // const user = useAppSelector(selectUser);

  // useEffect(() => {}, [user]);

  /**
   * Main Content
   */
  const [isMounted, setIsMounted] = useState(false);
  const shouldRender = useDelayUnmount(isMounted, 100);
  const { pathname } = useLocation();
  const outlet = useOutlet();

  useEffect(() => {
    setIsMounted(true);
  }, [pathname]);

  /**
   * Global Loading Indicator
   */
  const isLoading = useAppSelector(selectIsLoading);
  const [isGlobalLoadingMounted, setIsGlobalLoadingMounted] = useState(false);
  const shouldRenderGlobalLoading = useDelayUnmount(
    isGlobalLoadingMounted,
    400
  );
  useEffect(() => {
    setIsGlobalLoadingMounted(isLoading || isFetchingUser);
  }, [isLoading, isFetchingUser]);

  return userAccount ? (
    <>
      <NSCWrapper isMounted={isMounted} shouldRender={shouldRender}>
        {outlet}
      </NSCWrapper>
      {/* <ThemeSwitcher /> */}
      {(isFetchingUser || shouldRenderGlobalLoading) && (
        <LoadingGlobal isMounted={isGlobalLoadingMounted} />
      )}
      {isFetchingUser && (
        <LoadingAuth onSuccess={() => setIsFetchingUser(false)} />
      )}
    </>
  ) : (
    <Navigate to="/" />
  );
};
export default ProtectedRoute;
